/* eslint-disable array-callback-return */
import { gql } from '@/gql';
import { getApolloInstance } from '@/modules/graphql';

export const queryLocals = gql(`#graphql
  query Locals($search: String) {
    locals(search: $search) {
      id
      name
  }
}
`);

export const fetchLocals = async (params: { search?: string }) => {
  const apollo = getApolloInstance();
  const { data } = await apollo.query({
    query: queryLocals,
    fetchPolicy: 'network-only',
    variables: {
      search: params.search,
    },
  });

  const items = data?.locals || [];

  return {
    items,
    cursor: undefined,
  };
};
